module.exports = __webpack_public_path__ + "static/timpview-a20bad066d30525483f4cf3ed4d423e8.png";